<dx-load-panel
    class="wh-100"
    #loadPanel
    shadingColor="rgba(0,0,0,0.4)"
    [visible]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
></dx-load-panel>
<div class="loading-container" *ngIf="!isInitialized && !isPublicRoute" >
    <p-progressSpinner animationDuration="2s" strokeWidth="4"></p-progressSpinner>
</div>
<router-outlet *ngIf="isInitialized || isPublicRoute"></router-outlet>
<p-confirmDialog [closable]="true" key="verifyDatabaseVersionDialog"></p-confirmDialog>
<geaui-snackbar-v3></geaui-snackbar-v3>
<p-confirmDialog key="scriptStreamingDialog">
  <ng-template pTemplate="message">
    <div class="confirmation-dialog">
      <h4>Database Script Execution Logs</h4>
      <div #logContainer class="script-log-container">
        <div *ngFor="let log of scriptLogs">
          {{ log }}
        </div>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>
